import React from "react";
import {Button, Typography} from "antd";
import {EmptyStateContainer} from "./PoolsListModal.styles";

const {Text} = Typography;

const EmptyState = ({hasPools, city}) => (
    <EmptyStateContainer>
        <Text type="secondary">
            {hasPools ? "Arama sonucunda havuz bulunamadı" : "Bu şehir için henüz havuz bulunmuyor"}
        </Text>
        {!hasPools && (
            <Button
                type="primary"
                onClick={() => window.open(`/panel/pools/new?city=${city}`, "_blank")}
            >
                Havuz Üret
            </Button>
        )}
    </EmptyStateContainer>
);

export default EmptyState; 